import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { Login } from '../../views';

import { useAuth0 } from '../../services/auth0/react-auth0.spa';
import { debugLog } from 'shared/logger/debugLog';

export const LoginContainer = (): React.ReactElement | null => {
  const { isAuthenticated, loading } = useAuth0();

  debugLog(
    'LoginContainer: user authenticated:',
    isAuthenticated,
    'loading:',
    loading
  );

  // Wait for Auth0 to finish initializing before making routing decisions
  if (loading || isAuthenticated === undefined) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to='/issue' />;
  }

  return <Login />;
};
